import React from 'react'
import classNames from 'classnames'
import Button from 'components/UI/Button'

const ModalButton = ({ text, classes, callback }) => {
    const handleClick = () => {
        callback()
    }

    return (
        <Button
            trackName="modalButton"
            className={classNames(
                'button',
                'react-modal__modal-button', ...classes
            )}
            onClick={handleClick}
        >
            { text }
        </Button>
    )
}

export default ModalButton
